export interface CalculationResult {
  tag: string;
  price: number;
  investmentReturn: number;
  percentageChange: number;
}

export interface TableRow {
  tag: string; // S1, S2...
  price: number;
  values: CalculationResult[]; // R1, R2...
}

/**
 * Calculate investment returns from support to resistance levels.
 * @param invest - Investment amount
 * @param supportData - Support array (e.g. S1, S2)
 * @param resistanceData - Resistance array (e.g. R1, R2)
 */
export function calculateSupportResistanceTable(
  invest: number,
  supportData: { tag: string; price: number }[],
  resistanceData: { tag: string; price: number }[]
): TableRow[] {
  return supportData.map((support) => {
    const row: TableRow = {
      tag: support.tag,
      price: support.price,
      values: resistanceData.map((resistance) => {
        const percentageChange = ((resistance.price - support.price) / support.price) * 100;
        const investmentReturn = invest * (percentageChange / 100);
        return {
          tag: resistance.tag,
          price: resistance.price,
          investmentReturn: parseFloat(investmentReturn.toFixed(2)),
          percentageChange: parseFloat(percentageChange.toFixed(2)),
        };
      }),
    };
    return row;
  });
}
